module.exports = __webpack_public_path__ + "img/Imagestrat Logo RGB.9e64dd98.webp";